import { SlotsRow } from '@phaser/minigames/slots/Row';
import { DEPTH } from '@phaser/data/depth';
import { Game } from '@phaser/scenes/Game';

export const NUMBERS = ['OP', 'MJ', 'CV', 'UF', 'ZG', 'KJ'];
export const GAP = 15;
export const CELL_SIZE = 70;
export const ROW_HEIGHT = CELL_SIZE * 4;

export class SlotsMinigame {
  private _wanted: Phaser.GameObjects.Text[] = [];
  private _lane?: Phaser.GameObjects.Rectangle;
  private _scene: Game = Game.current;
  private _rows: SlotsRow[] = [];
  private _successLanes = 0;
  private _xOffset = 0;
  private _yOffset = 0;

  constructor() {}

  public start() {
    this._measure();
    this._placeRows();
    this._placeLane();
    this._placeWanted();
  }

  public restart() {
    if (!this._scene.minigameSystem.hasTimeLeft) return;

    this.destroy();
    this.start();
  }

  public destroy() {
    this._rows.forEach(row => row.destroy());
    this._lane?.destroy();
    this._wanted.forEach(w => w.destroy());

    this._rows = [];
    this._wanted = [];
    this._successLanes = 0;
  }

  public rowStop(text: string, index: number) {
    const wanted = this._wanted[index];
    wanted.setColor(wanted.text === text ? '#00DDFF' : '#FF0000');

    if (wanted.text === text) this._successLanes++;

    if (this._successLanes === 4 || wanted.text !== text) {
      this._rows.forEach(row => row.stopRow(false));
      setTimeout(() => {
        if (this._successLanes === 4) {
          this._scene.minigameSystem.success();
        } else {
          this.restart();
        }
      }, 1000);
    }
  }

  public update(_time: number, delta: number) {
    this._rows.forEach(row => row.update(_time, delta));
  } 

  private _placeWanted() {
    const camera = this._scene.cameras.main;
    const height = camera.displayHeight;

    for (let i = 0; i < 4; i++) {
      const xPos = i * CELL_SIZE + GAP * i + GAP + this._xOffset + CELL_SIZE / 2;
      const yPos = height / 2 + ROW_HEIGHT / 2 + CELL_SIZE / 2;
      const seq = NUMBERS[Math.floor(Math.random() * NUMBERS.length)];

      this._wanted.push(this._scene.add.text(xPos, yPos, seq, {
        fontFamily: 'Ascentian',
        fontSize: '32px',
        resolution: 2,
      }).setOrigin(0.5).setDepth(DEPTH.MINIGAME));
    }
  }

  private _placeLane() {
    const camera = this._scene.cameras.main;
    const width = camera.displayWidth;
    const height = camera.displayHeight;

    const laneWidth = 4 * CELL_SIZE + GAP * 5;
    const laneHeight = CELL_SIZE;

    this._lane = this._scene.add.rectangle(width / 2, height / 2, laneWidth, laneHeight)
      .setStrokeStyle(2, 0x00DDFF).setDepth(DEPTH.MINIGAME);
  }

  private _placeRows() {
    for (let i = 0; i < 4; i++) {
      const xPos = i * CELL_SIZE + GAP * i + GAP + this._xOffset;
      const yPos = this._yOffset;
      const direction = Math.random() < 0.5 ? 'down' : 'up';

      const row = new SlotsRow(this, i, xPos, yPos, CELL_SIZE, ROW_HEIGHT, direction);
      this._rows.push(row);
    }
  }

  private _measure() {
    const camera = this._scene.cameras.main;
    const width = camera.displayWidth;
    const height = camera.displayHeight;

    this._xOffset = (width - 4 * CELL_SIZE - GAP * 5) / 2;
    this._yOffset = (height - ROW_HEIGHT) / 2;
  }
}